import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  Row,
  Col,
  Input,
  Button,
  Table,
  Layout,
  Space,
  Form,
  Modal,
  message,
  Popconfirm,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import BreadMe from "../lib/Breadme";
import NetworkApi from "../../network/networkApi";
import usePlantType from "../../hooks/usePlantType";
import PlantDateChangeLog from "./PlantDateChangeLog";

const PlantType = () => {
  const [content, loadContent, changeContentFilter] = usePlantType(1);
  const [addEdit, setAddEdit] = useState({
    visible: false,
    edit: null,
  });

  const deleteItem = useCallback(async (data) => {
    let response = await NetworkApi.requestPost(
      "/api/farmland/plant/type/update",
      {
        ...data,
        status: "D",
      }
    );
    if (response.resultCode == 200) {
      message.success("Амжилттай устгагдлаа");
      loadContent();
    } else {
      message.error(response.message || "system error");
    }
  }, []);
  const elementInfo = [
    {
      title: "Таримлын төрөл",
      dataIndex: "name",
    },
    {
      title: "Код",
      dataIndex: "code",
    },
    {
      title: "Тайлбар",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Үйлдэл",
      render: (item: any) => (
        <Space size={10}>
          <Button
            onClick={() => setAddEdit({ visible: true, edit: item })}
            type={"primary"}
            size={"small"}
            ghost
            icon={<EditOutlined />}
          />
          <Popconfirm
            title="Устгахдаа итгэйлтэй байна уу"
            onConfirm={() => deleteItem(item)}
            okText="Тийм"
            cancelText="Үгүй"
          >
            <Button
              onClick={() => {}}
              type={"primary"}
              size={"small"}
              danger
              ghost
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleParam = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
  };

  return (
    <>
      <BreadMe title={["Системийн утгууд", "Таримлын төрөл"]} />
      <Layout.Content
        style={{ background: "#fff", padding: 24, margin: 0, minHeight: 280 }}
      >
        <Row style={{ marginTop: 15, marginBottom: 15 }}>
          <Col span={24}>
            <Row justify={"end"}>
              <Button
                onClick={() => setAddEdit({ visible: true, edit: null })}
                type={"primary"}
                icon={<PlusSquareOutlined />}
              >
                Таримлын төрөл нэмэх
              </Button>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table
              columns={elementInfo}
              dataSource={content.result}
              onChange={handleParam}
              rowKey={"id"}
              scroll={{ x: true }}
            />
          </Col>
        </Row>
      </Layout.Content>
      <PlantTypeAddEdit
        edit={addEdit.edit}
        visible={addEdit.visible}
        onHide={() => setAddEdit({ visible: false, edit: null })}
        onSuccess={() => {
          loadContent();
          setAddEdit({ visible: false, edit: null });
        }}
      />
    </>
  );
};

interface Props {
  edit?: any;
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const PlantTypeAddEdit = ({ edit, visible, onHide, onSuccess }: Props) => {
  const formRef = useRef<any>();
  useEffect(() => {
    if (visible) {
      if (edit) {
        formRef.current?.setFieldsValue(edit);
      } else {
        formRef.current?.resetFields();
      }
    }
  }, [edit, visible]);
  const saveContent = useCallback(
    async (data: any) => {
      if (edit) {
        data = { ...edit, ...data };
      }
      let response = await NetworkApi.requestPost(
        "/api/farmland/plant/type/update",
        data
      );
      if (response.resultCode == 200) {
        onSuccess();
      } else {
        message.error(response.message || "system error");
      }
    },
    [edit]
  );
  return (
    <Modal
      width={900}
      visible={visible}
      title={edit ? "Таримлын төрөл засах" : "Таримлын төрөл нэмэх"}
      onCancel={onHide}
      footer={null}
    >
      <Form ref={formRef} labelCol={{ span: 6 }} onFinish={saveContent}>
        <Form.Item name="name" label="Төрөл">
          <Input placeholder={"Таримлын төрлийн нэр"} />
        </Form.Item>
        <Form.Item name="code" label="Код">
          <Input placeholder={"Код"} />
        </Form.Item>
        <Form.Item name="description" label="Тайлбар">
          <Input placeholder={"Таримлын төрлийн тайлбар"} />
        </Form.Item>
        <Form.Item label="Тариалалтын хугацаа (сар)">
          <Space>
            <Form.Item name="cultivationStartMonth" noStyle initialValue={1}>
              <InputNumber min={1} max={12} placeholder="Эхлэх сар" />
            </Form.Item>
            <span>-</span>
            <Form.Item name="cultivationEndMonth" noStyle initialValue={12}>
              <InputNumber min={1} max={12} placeholder="Дуусах сар" />
            </Form.Item>
          </Space>
        </Form.Item>
        <Form.Item label="Ургац хураалтын хугацаа (сар)">
          <Space>
            <Form.Item name="harvestStartMonth" noStyle initialValue={1}>
              <InputNumber min={1} max={12} placeholder="Эхлэх сар" />
            </Form.Item>
            <span>-</span>
            <Form.Item name="harvestEndMonth" noStyle initialValue={12}>
              <InputNumber min={1} max={12} placeholder="Дуусах сар" />
            </Form.Item>
          </Space>
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Хадгалах
        </Button>
        {edit && (
          <div style={{ marginTop: 20 }}>
            <PlantDateChangeLog plantTypeId={edit.id} />
          </div>
        )}
      </Form>
    </Modal>
  );
};
export default PlantType;
